import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Landing.css';

const Landing: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  if (!isLoading && isAuthenticated) {
    navigate('/dashboard', { replace: true });
    return null;
  }

  return (
    <div className="landing-page">
      <div className="landing-bg">
        <div className="landing-bg-gradient" />
        <div className="landing-bg-grid" aria-hidden />
        <div className="landing-bg-glow landing-bg-glow-1" />
        <div className="landing-bg-glow landing-bg-glow-2" />
      </div>

      <main className="landing-main">
        <div className="landing-brand">
          <div className="landing-logo-wrap">
            <img src="/logo.png" alt="YuvanAPI" className="landing-logo" />
            <p className="landing-tagline">Empowering Fintech Solutions</p>
            <h1 className="landing-headline">YuvanAPI System</h1>
          </div>
          <p className="landing-desc">
            Secure admin portal for users, reports, and payouts.
          </p>
        </div>
        <div className="landing-cta">
          <Link to="/login" className="landing-btn">
            Sign in to dashboard
          </Link>
        </div>
        <p className="landing-credit">Built by Algobasket</p>
      </main>
    </div>
  );
};

export default Landing;
